import React from 'react'
import { CellStyle, LineStyle, P } from '../styles'

interface Column {
  key: string
  width?: string
  minWidth?: string
  onClick?: (cellProp: any) => void
  Component?: (data: any) => JSX.Element
}

interface BodyLineProps {
  model: Column[]
  lineHeight?: string
  noHover?: boolean
  rowSeparator?: boolean
  item?: any
}

export const BodyLine = ({ model, item, lineHeight, noHover, rowSeparator }: BodyLineProps): JSX.Element => {
  return (
    <LineStyle
      height={lineHeight}
      noHover={noHover}
      separator={rowSeparator}
      onClick={item.onClick ? item.onClick : undefined}
      data-testid={'table-line'}
    >
      {model.map((column: Column, i) => {
        const { key, width, minWidth, Component } = column

        return (
          <CellStyle data-testid="table-cell" key={i} length={model.length} width={width} minWidth={minWidth}>
            {Component ? <Component {...item} /> : <P>{item[key]}</P>}
          </CellStyle>
        )
      })}
    </LineStyle>
  )
}
